import EditIcon from '@mui/icons-material/Edit';
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Logos from '../../components/logos';
import PageTransition from '../../components/PageTransition/PageTransition';
import Auth_APIs from '../../utilities/api/auth_api';
import background from '../../utilities/dummy_assets/background.png';

export default function PreviewAdmin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedAdminType, setSelectedAdminType] = useState('Admin');

  // States for form validation
  const [showValidation, setShowValidation] = useState(false);
  const [errors, setErrors] = useState({});

  // States for Admin form
  const [profilePic, setProfilePic] = useState(
    location.state?.profilePic || null
  );
  const [position, setPosition] = useState(
    location.state?.position || { id: '', label: '' }
  );
  const [agreed, setAgreed] = useState(false);
  // console.log(location.state);
  // States for MBF Admin form
  const [mbfEmail, setMbfEmail] = useState('');
  const [mbfName, setMbfName] = useState('');
  const [mbfPhone, setMbfPhone] = useState('');
  // const [tinkerLabsList, setTinkerLabsList] = useState([]);
  const POSITION_CHOICES = [
    { id: '0', name: 'TL student management body' },
    { id: '1', name: 'Manager (other technical clubs)' },
    { id: '2', name: 'TL Manager' },
    { id: '3', name: 'TL Technician' },
    { id: '4', name: 'Other' },
    { id: '5', name: 'Professor In Charge' },
  ];
  // Validation rules
  const validateForm = () => {
    const errors = {};

    if (selectedAdminType === 'Admin') {
      if (!position?.id) errors.position = 'Please select your position';
      // if (!agreed) errors.agreed = 'Please agree to the terms';
      if (!profilePic) errors.profilePic = 'Please upload a profile picture';
    } else {
      if (!mbfEmail) {
        errors.mbfEmail = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(mbfEmail)) {
        errors.mbfEmail = 'Email is invalid';
      }

      if (!mbfName.trim()) {
        errors.mbfName = 'Name is required';
      } else if (!/^[A-Za-z\s]+$/.test(mbfName.trim())) {
        errors.mbfName = 'Name can only contain letters and spaces';
      }

      if (!mbfPhone) {
        errors.mbfPhone = 'Phone number is required';
      } else if (!/^[0-9]{10}$/.test(mbfPhone)) {
        errors.mbfPhone = 'Phone number must be 10 digits';
      }

      // if (!agreed) errors.agreed = "You must agree to the terms";
      if (!profilePic) errors.profilePic = 'Please upload a profile picture';
    }

    setErrors(errors);
    console.log(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChangePosition = event => {
    const selectedPosition = POSITION_CHOICES.find(
      pos => pos.id === event.target.value
    );
    if (selectedPosition) {
      const newPosition = {
        id: selectedPosition.id,
        label: selectedPosition.name,
      };
      setPosition(newPosition);
      // Update the position in the location state
      navigate(location.pathname, {
        state: {
          ...location.state,
          position: newPosition,
          capturedImage: profilePic,
        },
        replace: true,
      });
    } else {
      setPosition({ id: '', label: '' });
    }
  };

  // Initialize form state from location state when component mounts
  useEffect(() => {
    if (location.state) {
      if (location.state.capturedImage) {
        setProfilePic(location.state.capturedImage);
      }
      if (location.state.position) {
        setPosition({
          id: location.state.position.id || '',
          label: location.state.position.label || '',
        });
      }
      // console.log(location.state?.email);
      if (location.state?.email) {
        setMbfEmail(location.state.email);
      }
      if (location.state?.name) {
        setMbfName(location.state.name);
      }
      if (location.state?.phone) {
        setMbfPhone(location.state.phone);
      }
      if (location.state?.agreed) {
        setAgreed(location.state.agreed);
      }
    }
  }, [location.state]);
  const handleRegister = () => {
    setShowValidation(true);

    if (!validateForm()) {
      console.log('Validation errors:', errors);
      // Scroll to the first error
      const firstError = Object.keys(errors)[0];
      if (firstError) {
        const element = document.querySelector(`[data-error="${firstError}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      return;
    }

    if (selectedAdminType === 'Admin') {
      console.log('Admin Registered', { position });
      navigate('/register-submit-2', {
        state: {
          ...location.state,
          capturedImage: profilePic,
          position: {
            id: position.id,
            label: position.label,
          },
          agreed: agreed,
          // formData: {
          //   ...(location.state?.formData || {}),
          //   position: position.label,
          //   position_id: position.id
          // }
        },
      });
      // Proceed with Admin registration
    } else {
      console.log('MBF Admin Registered', {
        email: mbfEmail,
        name: mbfName,
        phone_number: mbfPhone,
        TL: 'MBF Admin',
      });
      // navigate to status page
      // Proceed with MBF Admin registration
    }
  };
  const dataURLtoBlob = dataurl => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  // const   handleRegisterSubmit2 = async() => {
  //   setShowValidation(true);
  //   const isValid = validateForm();

  //   if (isValid) {
  //     const formData = new FormData();
  //     const imageBlob = dataURLtoBlob(location.state.capturedImage);
  //     formData.append('name', mbfName);
  //     formData.append('email', mbfEmail);
  //     formData.append('phone_number', mbfPhone);
  //     formData.append('TL', "Org-Admin");
  //     formData.append('profile_pic', imageBlob, 'profile_pic.jpg');

  //     try {
  //       const response = await Auth_APIs.register(formData, {
  //         headers: {
  //           'Content-Type': 'multipart/form-data'
  //         }
  //       });

  //       console.log("Registration response:", response);

  //       if (response && (response.status === 200 || response.status === 201)) {
  //         // Navigate to check status page on successful registration
  //         navigate("/check-status", {
  //           state: {
  //             email: mbfEmail,
  //             status: 'pending'
  //           }
  //         });
  //         return;
  //       }
  //     } catch (error) {
  //       console.error('Registration API error:', error);

  //       // Handle Axios error response
  //       if (error.response) {
  //         // The request was made and the server responded with a status code
  //         // that falls out of the range of 2xx
  //         const { status, data } = error.response;
  //         let errorMessage = 'Registration failed. Please try again.';

  //         // Try to get detailed error message from response
  //         if (data) {
  //           if (typeof data === 'string') {
  //             errorMessage = data;
  //           } else if (data.detail) {
  //             errorMessage = data.detail;
  //           } else if (data.message) {
  //             errorMessage = data.message;
  //           } else if (data.non_field_errors) {
  //             errorMessage = data.non_field_errors[0];
  //           } else if (status === 400) {
  //             // Handle field-specific errors
  //             const fieldErrors = [];
  //             for (const [field, messages] of Object.entries(data)) {
  //               if (Array.isArray(messages)) {
  //                 fieldErrors.push(`${field}: ${messages.join(', ')}`);
  //               } else {
  //                 fieldErrors.push(`${field}: ${messages}`);
  //               }
  //             }
  //             if (fieldErrors.length > 0) {
  //               errorMessage = fieldErrors.join('\n');
  //             }
  //           }
  //         }

  //         toast.error(errorMessage);
  //         console.error('Detailed error:', {
  //           status: error.response.status,
  //           data: error.response.data,
  //           headers: error.response.headers
  //         });
  //       } else if (error.request) {
  //         // The request was made but no response was received
  //         console.error('No response received:', error.request);
  //         toast.error('No response from server. Please try again later.');
  //       } else {
  //         // Something happened in setting up the request
  //         console.error('Request setup error:', error.message);
  //         toast.error('Error setting up registration. Please try again.');
  //       }

  //       // Re-throw the error to be caught by the outer try-catch if needed
  //       throw error;
  //     }

  //   };
  // };

  const handleRegisterSubmit2 = async () => {
    setShowValidation(true);
    const isValid = validateForm();

    if (isValid) {
      try {
        console.log('Starting form submission...');
        const formData = new FormData();

        // Log form data before creating the request
        console.log('Form data before append:', {
          name: mbfName,
          email: mbfEmail,
          phone_number: mbfPhone,
          hasImage: !!location.state?.capturedImage,
        });

        const imageBlob = dataURLtoBlob(location.state.capturedImage);
        formData.append('name', mbfName);
        formData.append('email', mbfEmail);
        formData.append('phone_number', mbfPhone);
        formData.append('TL', 'MBF Admin');
        formData.append('profile_pic', imageBlob, 'profile_pic.jpg');

        // Log FormData contents (won't show in console, but helps with debugging)
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }

        console.log('Sending request to server...');
        const response = await Auth_APIs.register(formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          validateStatus: function (status) {
            // Always resolve the promise for all status codes
            return true;
          },
        });

        console.log('Server response:', {
          status: response.status,
          statusText: response.statusText,
          data: response.data,
          headers: response.headers,
        });

        if (response.status === 200 || response.status === 201) {
          console.log('Registration successful, navigating to check status');
          navigate('/check-status', {
            state: {
              email: mbfEmail,
              status: 'pending',
            },
          });
          return;
        }

        // If we get here, there was an error response
        const errorObj = new Error('Registration failed');
        errorObj.response = {
          status: response.status,
          data: response.data,
          headers: response.headers,
        };
        throw errorObj;
      } catch (error) {
        console.error('Full error object:', error);
        let errorMessage = 'Registration failed. Please try again.';
        if (error.email) {
          toast.error(
            'Email ID already registered or registration in progress. Please use a different email or contact admin.'
          );
          return;
        }

        if (error.response) {
          console.log('Error response:', error.response);
          const { status, data } = error.response;

          if (status === 400) {
            console.log('400 Bad Request data:', data);
            if (typeof data === 'string') {
              errorMessage = data;
            } else if (data.detail) {
              errorMessage = data.detail;
            } else if (data.message) {
              errorMessage = data.message;
            } else if (data.non_field_errors) {
              errorMessage = data.non_field_errors[0];
            } else {
              // Handle field-specific errors
              const fieldErrors = [];
              for (const [field, messages] of Object.entries(data)) {
                if (Array.isArray(messages)) {
                  fieldErrors.push(`${field}: ${messages.join(', ')}`);
                } else {
                  fieldErrors.push(`${field}: ${messages}`);
                }
              }
              if (fieldErrors.length > 0) {
                errorMessage = fieldErrors.join('\n');
              }
            }
          } else if (status === 401) {
            errorMessage = 'Authentication failed. Please login again.';
          } else if (status === 403) {
            errorMessage = 'You do not have permission to perform this action.';
          } else if (status === 409) {
            errorMessage = 'An account with this email already exists.';
          } else if (status >= 500) {
            errorMessage = 'Server error. Please try again later.';
          }
        } else if (error.request) {
          console.error('No response received:', error.request);
          errorMessage =
            'No response from server. Please check your connection and try again.';
        } else {
          console.error('Request setup error:', error.message);
          errorMessage = 'Error setting up registration. Please try again.';
        }

        // Show error to user
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        console.error('Error details:', {
          message: errorMessage,
          error: error,
          response: error.response,
          request: error.request,
        });
      }
    }
  };

  return (
    <Box
      sx={{
        // width: "100vw",
        minHeight: '100vh',
        overflow: 'hidden',
        display: 'flex',
        // justifyContent: "center"
        alignItems: 'center',
        backgroundImage: { sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: '1rem',
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Top right link */}
      <Box sx={{ position: 'absolute', top: 16, right: 32 }}>
        <Typography
          component="a"
          href="/student"
          sx={{ color: '#007bff', textDecoration: 'underline' }}
        >
          Go to student site
        </Typography>
      </Box>

      {/* Main Box containing toggle + form */}
      <PageTransition
        sx={{
          maxWidth:
            selectedAdminType === 'Admin'
              ? { xs: 400, sm: '50%' }
              : { xs: 900, sm: '60%' },
          margin: 'auto',
          // mt: 6,
          background: '#fff',
          marginTop: { xs: 10, sm: 'auto' },
          p: { sm: 2 },
          borderRadius: '10px',
          boxShadow: { sm: '0px 0px 20px rgba(0,0,0,0.1)' },
        }}
      >
        {/* Toggle buttons inside main box */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            // alignItems: "center",
            // backgroundColor: "red",
            // gap: 8,
            border: { xs: '1px solid #E6E6E6', sm: 'none' },
            borderTopLeftRadius: { xs: '10px' },
            borderTopRightRadius: { xs: '10px' },
            // mb: 2
          }}
        >
          <Button
            onClick={() => setSelectedAdminType('Admin')}
            sx={{
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '22px',
              color: selectedAdminType === 'Admin' ? '#000' : '#ccc',
              // textDecoration:
              //   selectedAdminType === "Admin" ? "underline" : "none",
              borderBottom:
                selectedAdminType === 'Admin' ? '2px solid black' : 'none',
              // backgroundColor: "yellow"
              borderRadius: 0,
              flex: 1,
            }}
          >
            Admin
          </Button>
          <Button
            onClick={() => setSelectedAdminType('MBF Admin')}
            sx={{
              textTransform: 'none',
              textAlign: 'center',
              fontWeight: 400,
              fontSize: '22px',
              color: selectedAdminType === 'MBF Admin' ? '#000' : '#ccc',
              borderBottom:
                selectedAdminType === 'MBF Admin' ? '2px solid black' : 'none',
              flex: 1,
              borderRadius: 0,
            }}
          >
            MBF Admin
          </Button>
        </Box>
        <Divider sx={{ mb: 3 }} />

        {selectedAdminType === 'Admin' ? (
          <>
            {/* profile pic */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 1,
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: '8px',
                  overflow: 'hidden',
                  border: '2px solid #ddd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f5f5f5',
                }}
              >
                {profilePic ? (
                  <img
                    src={profilePic}
                    alt="Profile"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <Avatar
                    sx={{ width: '100%', height: '100%', borderRadius: 0 }}
                  />
                )}
              </Box>
              <IconButton
                onClick={() => navigate('/profile-capture')}
                sx={{
                  position: 'absolute',
                  bottom: -5,
                  right: 'calc(50% - 60px)',
                  backgroundColor: '#fff',
                  border: '2px solid #ddd',
                  width: 32,
                  height: 32,
                  '&:hover': { backgroundColor: '#f5f5f5' },
                }}
              >
                <EditIcon sx={{ fontSize: 16, color: '#666' }} />
              </IconButton>
            </Box>

            {/* Position Dropdown */}
            <TextField
              select
              label="Position"
              fullWidth
              value={position.id}
              onChange={handleChangePosition}
              required
              error={showValidation && !position.id}
              helperText={
                showValidation && !position.id
                  ? 'Please select your position'
                  : ''
              }
              sx={{
                mb: 2,
                '& .MuiOutlinedInput-root fieldset': {
                  borderColor:
                    showValidation && !position ? '#d32f2f' : undefined,
                },
                textAlign: 'left',
              }}
            >
              <MenuItem value="">Select your position</MenuItem>
              {POSITION_CHOICES.map(position => (
                <MenuItem key={position.id} value={position.id}>
                  {position.name}
                </MenuItem>
              ))}
            </TextField>

            <Typography
              variant="caption"
              sx={{
                backgroundColor: '#FFF7E0',
                color: '#C17C00',
                p: 1,
                borderRadius: 1,
                mb: 2,
                display: 'block',
                fontSize: '13px',
                textAlign: 'left',
                lineHeight: 1.4,
              }}
            >
              ⚠️ Once you enter the position and move to the next page, you
              can't change it.
            </Typography>

            {/* <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreed}
                    onChange={(e) => setAgreed(e.target.checked)}
                    sx={{
                      color: showValidation && !agreed ? "#d32f2f" : undefined,
                      "&.Mui-checked": { color: "#007bff" },
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      color: showValidation && !agreed ? "#d32f2f" : undefined,
                      fontSize: "14px",
                      textAlign: 'left',
                    }}
                  >
                    By using the MBF MIS, you consent to the processing of your information.*
                  </Typography>
                }
                sx={{ alignItems: 'center' }}
              />
            </Box>
            {showValidation && !agreed && (
              <Typography
                variant="caption"
                sx={{ color: "#d32f2f", fontSize: "12px", mt: -1, mb: 1 }}
              >
                Please agree to the terms to continue
              </Typography>
            )} */}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '5px',
              }}
            >
              <Button
                variant="outlined"
                onClick={() => navigate('/login')}
                sx={{
                  flex: 1,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleRegister}
                sx={{
                  backgroundColor: '#007bff',
                  flex: 1,
                }}
              >
                Next
              </Button>
            </Box>
            <Box
              sx={{ mt: 2 }}
              display="flex"
              justifyContent="right"
              alignItems="center"
            >
              Already Have an Account?
              <Button variant="text" onClick={() => navigate('/login')}>
                Login
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Box sx={{ position: 'relative', display: 'inline-block' }}>
                {profilePic ? (
                  <img
                    src={profilePic}
                    alt="Profile"
                    style={{
                      width: '120px',
                      height: '120px',
                      objectFit: 'cover',
                      borderRadius: '5px',
                      border:
                        showValidation && !profilePic
                          ? '2px solid #d32f2f'
                          : '2px solid #ddd',
                    }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: '120px',
                      height: '120px',
                      borderRadius: '5px',
                      border:
                        showValidation && !profilePic
                          ? '2px solid #d32f2f'
                          : '2px solid #ddd',
                    }}
                  />
                )}
                <IconButton
                  onClick={() => navigate('/profile-capture')}
                  sx={{
                    position: 'absolute',
                    bottom: -5,
                    right: -5,
                    backgroundColor: '#fff',
                    border: '2px solid #ddd',
                    width: 32,
                    height: 32,
                    '&:hover': { backgroundColor: '#f5f5f5' },
                  }}
                >
                  <EditIcon sx={{ fontSize: 16, color: '#666' }} />
                </IconButton>
              </Box>
              {showValidation && !profilePic && (
                <Typography
                  color="error"
                  variant="caption"
                  display="block"
                  sx={{ mt: 1 }}
                >
                  {errors.profilePic}
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: 2,
                mb: 2,
              }}
            >
              <TextField
                label="Email Address"
                value={mbfEmail}
                onChange={e => {
                  setMbfEmail(e.target.value);
                  if (showValidation) validateForm();
                }}
                error={showValidation && !!errors.mbfEmail}
                helperText={showValidation && errors.mbfEmail}
                fullWidth
                required
              />
              <TextField
                label="Name"
                value={mbfName}
                onChange={e => {
                  setMbfName(e.target.value);
                  if (showValidation) validateForm();
                }}
                error={showValidation && !!errors.mbfName}
                helperText={showValidation && errors.mbfName}
                fullWidth
                required
              />
              <TextField
                label="Phone No."
                value={mbfPhone}
                onChange={e => {
                  // Only allow numbers
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === '' || re.test(e.target.value)) {
                    setMbfPhone(e.target.value);
                    if (showValidation) validateForm();
                  }
                }}
                inputProps={{ maxLength: 10 }}
                error={showValidation && !!errors.mbfPhone}
                helperText={showValidation && errors.mbfPhone}
                fullWidth
                required
              />
              <TextField
                label="Position"
                value="MBF Admin"
                disabled
                fullWidth
              />
            </Box>

            {/* <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2, mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreed}
                    onChange={(e) => {
                      setAgreed(e.target.checked);
                      if (showValidation) validateForm();
                    }}
                    sx={{
                      color: showValidation && !agreed ? "#d32f2f" : undefined,
                      "&.Mui-checked": { color: "#007bff" },
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      color: showValidation && !agreed ? "#d32f2f" : undefined,
                      fontSize: "14px",
                      textAlign: 'left',
                    }}
                  >
                    By using the MBF MIS, you consent to the processing of your information.*
                  </Typography>
                }
                sx={{ alignItems: 'center' }}
              />
            </Box>
            {showValidation && !agreed && (
              <Typography color="error" variant="caption" display="block" sx={{ mt: -1, mb: 1 }}>
                {errors.agreed}
              </Typography>
            )}  */}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                mt: 2,
                gap: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={() => navigate('/profile-capture')}
                sx={{
                  flex: 1,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleRegisterSubmit2}
                sx={{ backgroundColor: '#007bff', flex: 1 }}
              >
                Register
              </Button>
            </Box>
            <Box
              sx={{ mt: 2 }}
              display="flex"
              justifyContent="right"
              alignItems="center"
            >
              Already Have an Account?
              <Button variant="text" onClick={() => navigate('/login')}>
                Login
              </Button>
            </Box>
          </>
        )}
      </PageTransition>

      {/* Footer Logos */}
      <Logos />
    </Box>
  );
}
